import LoadingPhases from "@/components/LoadingPhases.vue";
import router from "@/router";
import Util from "@/ts/Util";
import axios from "axios";
import NProgress from "nprogress";
import { Component, Vue } from "vue-property-decorator";

declare let document: any;
declare let window: any;
@Component
export default class Request extends Vue {
  body: object = {};
  documentFormData: FormData = new FormData();
  route = "";
  callbackSuccess: Function = new Function();
  callbackError: Function = new Function();
  blockTouchEvents = false;
  loadingMessage = "Carregando";
  successMessage = "Sucesso";
  errorMessage = "Erro";
  private isFirstTry = true;
  showLoader = true;
  expired = false;

  visibilityOptions: any = { success: false, error: false, loading: false };

  static urlBase: string =
    process.env.VUE_APP_API_BASE_URL ||
    "https://eattake.com/backend/index.php/";

  // Function which makes the request
  send($config: Object = {}) {
    if (!Request.urlBase) {
      console.error(
        "VUE_APP_API_BASE_URL não está definida e não há fallback. A aplicação pode não funcionar corretamente."
      );
    }
    const urlReq: string = Request.urlBase + this.route;
    const self = this;

    this.startLoading();

    let reqBody;
    if (Object.entries(this.body).length > 0) {
      reqBody = {
        requestType: "Row",
        row: Object.assign(this.body),
      };
    } else {
      reqBody = this.documentFormData;
    }

    return axios
      .post(urlReq, reqBody, $config)
      .then((response) => {
        NProgress.done();
        const lp: any = LoadingPhases;
        if (
          "response" in response.data.dataset &&
          "res" in response.data.dataset.response &&
          "des_erro" in response.data.dataset.response.res
        ) {
          if (
            response.data.dataset.response.res.des_erro ===
              "Sua sessão expirou! Favor efetue login novamente!" ||
            response.data.dataset.response.res.code === 401
          ) {
            this.expired = true;
            sessionStorage.setItem("USER_ID", "");
            sessionStorage.setItem("TOKEN", "");
            sessionStorage.setItem("REFRESH_TOKEN", "");
            sessionStorage.setItem("TOKEN_EXT", "");
            sessionStorage.setItem("ID_EXT", "");
            sessionStorage.setItem("KEY_EXT", "");
            sessionStorage.setItem("TOTP", "");
            sessionStorage.setItem("GET_MODALITY_FROM_LS", "");
            this.expiredSession(response.data.dataset.response.res.des_erro);
          }
        } else if (this.visibilityOptions.success) {
          lp.start(lp.SUCCESS, this.successMessage);
        } else {
          if (this.blockTouchEvents) this.unblockTouch();
        }
        if (this.visibilityOptions.loading && !this.expired)
          this.finishLoading();
        const requestData: any = response.data.dataset;
        self.callbackSuccess(requestData);
        return requestData;
      })
      .catch((error) => {
        NProgress.done();
        if (this.visibilityOptions.loading) self.finishLoading();
        if (
          error &&
          error.response &&
          error.response.data &&
          (error.response.data.errorCode == 42 ||
            error.response.data.errorCode == 43 ||
            error.response.data.errorCode == 1 ||
            error.response.data.errorCode == 3)
        ) {
          self.generateSession();
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.errorCode == 11
        ) {
          sessionStorage.setItem("IS_AUTHORIZED_EXTERNAL", "UNAUTHORIZED");
          sessionStorage.setItem("USER_ID", "");
          sessionStorage.setItem("TOKEN", "");
          sessionStorage.setItem("REFRESH_TOKEN", "");
          sessionStorage.setItem("TOKEN_EXT", "");
          sessionStorage.setItem("ID_EXT", "");
          sessionStorage.setItem("KEY_EXT", "");
          sessionStorage.setItem("TOTP", "");

          setTimeout(function () {
            router.push("LogIn");
          }, 250);
        } else {
          if (this.visibilityOptions.error) {
            const lp: any = LoadingPhases;
            lp.start(lp.ERROR, this.errorMessage);
          }
          self.callbackError(error);
        }
      });
  }

  showErrorMessage(message: string) {
    const lp: any = LoadingPhases;
    lp.start(lp.ERROR, message);
  }

  showSuccessMessage(message: string) {
    const lp: any = LoadingPhases;
    lp.start(lp.SUCCESS, message);
  }

  startLoading() {
    if (this.visibilityOptions.loading) {
      const lp: any = LoadingPhases;
      lp.start(lp.LOADING, this.loadingMessage);
      Util.closeKeyboard();
    } else {
      if (this.showLoader) NProgress.start();
    }

    if (this.blockTouchEvents) {
      this.blockTouch();
      //$('#loading-overlay').show();
    }
  }

  finishLoading() {
    NProgress.done();
    if (this.blockTouchEvents) {
      this.unblockTouch();
    }
    const lp: any = LoadingPhases;

    lp.stop();
  }

  blockTouch() {
    $("body").css("pointer-events", "none");
    $("html").css("pointer-events", "none");
  }

  unblockTouch() {
    $("body").css("pointer-events", "auto");
    $("html").css("pointer-events", "auto");
  }

  generateSession() {
    if (this.isFirstTry) {
      const self = this;
      const userId: string = sessionStorage.getItem("USER_ID") || "";
      const refreshTKN: string = sessionStorage.getItem("REFRESH_TOKEN") || "";

      const req = new Request();
      req.body = {
        USER_ID: userId,
        REFRESH_TOKEN: refreshTKN,
      };
      req.route = "requestToken";
      req.callbackSuccess = function (response: any) {
        sessionStorage.setItem("TOKEN", response.user.token);
        self.remakeRequest();
      };
      req.callbackError = function (error: any) {
        console.log(error);
        self.callbackError(error);
      };
      req.showLoader = false;
      req.send();
    } else {
      this.showErrorMessage(
        "Sua sessão expirou! Favor fazer o login novamente."
      );
      router.push("LogIn");
    }
  }

  remakeRequest() {
    this.isFirstTry = false;
    this.send();
  }

  expiredSession(msgErro: string) {
    this.finishLoading();
    this.showErrorMessage(msgErro);
    router.push("BeginningCreatePassword");
  }

  async get(): Promise<any> {
    const urlReq: string = Request.urlBase + this.route;
    this.startLoading();
    const response = await axios.get(urlReq);

    return response.data.dataset;
  }
}
